<template>
    <div
        class="article-details"
        id="main-container"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
        <div class="article">
            <div class="article-head">
                <div class="head-title">
                    <div class="title">{{ articleContent.name }}</div>
                </div>
            </div>
            <div v-if="isbuy" class="article-buy-container">
                <div class="article-pdf" v-if="!!articleContent.pdf_file">
                    <pdf :url="articleContent.pdf_file"></pdf>
                </div>
                <!-- <div class="article-video" v-if="articleContent.video">
          <video
            class="myVideo"
            width="100%"
            height="100%"
            controls
            :src="articleContent.video"
          >你的浏览器不支持视频播放</video>
                </div>-->
            </div>
            <div v-else>
                <div v-if="articleContent.img">
                    <div class="article-content" v-html="articleContent.description"></div>
                    <div class="buy-video">
                        <img :src="articleContent.img" alt />
                        <div class="buy-video-tip">
                            <img @click="buyVideo" :src="videoPlay|imageFmt()" alt />
                        </div>
                    </div>
                </div>
            </div>
            <div class="article-tag">
                <div>撰稿时间：{{ articleContent.time }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pdf from '../../components/common/Pdf.vue';

    export default {
        components: { Pdf },
        data() {
            return {
                isScreen: false, // 是否全屏
                loading: false,
                isbuy: 1,
                advList: {},
                articleContent: {
                    pdf_file: '',
                    img: '',
                    time: '',
                    name: ''
                },
                videoDialog: false,
                videoCreate: {},
                collect: 0, // 是否收藏
                videoPlay: 'video-play',
                commentList: {}, // 评论列表
                order: 'desc', // 评论排序
                page: 1, // 一级评论页数
                numPages: 1, // pdf总页数
                pdfUrl: ''
            };
        },
        computed: {
            login() {
                return !!this.$store.state.login.token;
            },
            insufficient() {
                return (
                    this.$store.state.login.userInfo.balance <
                    this.articleContent.amount
                );
            }
        },
        created() {
            console.log('routerr', this.$route);
            this.loading = true;
            this.getdetail();
            window.scrollTo(0, 0);
        },
        methods: {
            getdetail() {
                this.httpGet(this.$root.cfbbDetail)
                    .then(res => {
                        this.articleContent = res;
                        this.loading = false;
                        console.log('uuuuu', this.articleContent, 'ffff', res);
                    })
                    .catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
            }
        },
        watch: {
            articleContent: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    console.log(
                        'articleContent-45555555555-newValue, oldValue',
                        newValue,
                        oldValue
                    );
                    // if (newValue.video) {
                    this.articleContent.video = newValue.video;
                    // }
                }
            }
        }
    };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import '~assets/main.styl';

    .el-main {
        padding: unset;
        margin-top: 18px;
    }

    .article-details {
        margin-top: 10px;
    }

    .article {
        width: 100%;
        background: white;
        padding: 24px;
        min-height: 580px;
    }

    .article-head {
        border-bottom: 1px solid grayE8;
        min-height: 74px;
        font-size: 16px;
        color: gray3;
        line-height: 21px;
    }

    .head-title {
        flex-center();
        margin-top: 10px;
        text-align: center;
    }

    .title {
        width: 90%;
        font-size: 36px;
        color: gray3;
        line-height: 47px;
    }

    .head-option {
        flex-x(flex-end);
        color: gray6;

        div {
            margin-right: 10px;
        }

        svg {
            width: 16px;
            height: 16px;
            fill: gray9;
            border-radius: 1px;
        }

        .buy {
            fill: blue;
        }
    }

    .article-tag {
        width: 100%;
        flex-x(space-between);
        font-size: 12px;
        color: gray9;
        line-height: 26px;
        margin-top: 10px;
        flex-wrap: wrap;

        div {
            margin-right: 20px;
        }

        .view {
            display: flex;
            justify-content: flex-end;
        }

        &.other {
            flex-x(flex-start);
            width: 100%;
            flex-wrap: wrap;

            .other-item {
                margin-right: 20px;
            }
        }
    }

    .article-content >>> img {
        width: 100%;
    }

    .article-content {
        // max-width: 702px;
        font-size: 14px;
        color: gray3;
        line-height: 28px;
        text-indent: 2em;
        margin: auto;
        margin-top: 30px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .article-pdf {
        min-height: 840px;
        height: 100%;
        // height: 840px;
        // overflow-y scroll
        margin-bottom: 50px;
        position: relative;

        .btn {
            width: 100%;
            text-align: right;
            margin-bottom: 10px;
            cursor: pointer;
            flex-x(flex-end);

            .icon {
                width: 16px;
                height: 16px;
                fill: blue;
                margin-right: 10px;
            }

            p {
                color: blue;
            }
        }
    }

    .article-video {
        margin: 30px;
    }

    >>> .ql-container.ql-snow {
        border: 0px solid #ccc !important;
    }

    .similar {
        border-top: 1px solid grayE8;
        padding: 25px 16px;
        margin-top: 150px;
    }

    .similar-title {
        font-size: 14px;
        color: gray3;
        line-height: 19px;
    }

    .text {
        flex-x(space-between);
        margin-top: 10px;
        font-size: 14px;
        color: gray6;
        line-height: 22px;
    }

    .text:hover {
        color: blue;
        cursor: pointer;

        p {
            color: blue;
        }

        .cell-icon {
            background: blue;
        }
    }

    .cell-text {
        flex-x(flex-start);
        max-width: 85%;

        p {
            width: 100%;
            ellipsis();
        }
    }

    .cell-icon {
        width: 6px;
        height: 6px;
        background: grayE8;
        margin-right: 8px;
    }

    .blue-tip {
        margin: 20px 0;
        font-size: 14px;
        color: blue;
        line-height: 19px;
    }

    .buy-video {
        margin-top: 20px;

        img {
            width: 698px;
            height: 436px;
        }

        .buy-video-tip {
            width: 698px;
            height: 436px;
            margin-top: -436px;
            // background: rgba(0, 0, 0, 0.5);
            // position: relative;
            flex-center();

            img {
                width: 157px;
                height: 111px;
                opacity: 0.7;
            }
        }

        .blue-tip {
            margin: 20px 0;
            font-size: 14px;
            color: yellow;
            line-height: 19px;
        }
    }

    .dialog-contianer {
        flex-y();

        .dialog-title {
            font-size: 16px;
            color: gray3;
            line-height: 21px;
        }

        .dialog-amount {
            font-size: 14px;
            color: gray9;
            line-height: 19px;
            margin-top: 20px;
        }
    }

    .insufficient {
        font-size: 14px;
        color: red;
        line-height: 19px;
        margin-top: 20px;
    }

    .primary {
        margin-top: 20px;
    }

    .video-container {
        flex-x();
        width: 100%;
        flex-wrap: wrap;
    }

    .single-video {
        padding: 16px 0;
        // height: 10%;
        width: 30%;
        margin: 10px 0;
    }

    .attachment {
        // margin-left: 2em;
        font-size: 14px;
        color: blue;
        margin-top: 5px;

        a {
            margin-top: 10px;
            font-size: 14px;
            line-height: 25px;
            color: blue;
        }
    }

    .collect-fee {
        width: 832px;
        height: 158px;
        background: rgba(240, 240, 240, 1);
        margin: auto;
        margin-top: 35px;
        flex-y();

        .collect-btn {
            flex-x();
            margin-top: 15px;
        }
    }

    .comment-wrap {
        width: 832px;
        background: white;
        min-height: 300px;
        margin-top: 15px;
        padding: 24px;

        .comment-user {
            .comment-nologin {
                width: 832px;
                height: 80px;
                background: rgba(250, 250, 250, 1);
                border-radius: 4px;
                border: 1px solid rgba(244, 244, 244, 1);
                margin: auto;
                flex-x(center, center);
                font-size: 14px;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                line-height: 45px;

                span {
                    margin-left: 16px;
                    height: 67px;
                    line-height: 80px;
                }
            }
        }
    }

    .comment-list {
        .side-class-title {
            padding: unset;
            border: none;
        }

        .nomore {
            width: 100%;
            height: 71px;
            flex-center();
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.25);
            line-height: 22px;
        }
    }
</style>
